import React, { Component } from 'react';
import Amplify from 'aws-amplify';
import { ToastContainer, toast } from 'react-toastify';
import * as AppActionCreators from './store/actions/app.Actions';
import { Navigate, Route, Routes } from 'react-router-dom';
import { connect } from 'react-redux';
import { AppState } from './store/state/app.state';
import { bindActionCreators, Dispatch } from 'redux';
import _ from 'lodash';
import { MainLayout, Spinner } from './layout';
import LoginPage from './pages/login/LoginPage';
import { IApplicationProps } from './types/PropTypes';
import amplifyConfig from './utils/amplifyConfig';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import LoginService from './services/login/login-service';
import LoginAPIService from './services/login/loginApi-service';
import Drivers from './pages/driver/Drivers';
import ability from './ability';
import { Common } from './utils/constants';
import CookieConsent from 'react-cookie-consent';
import { TFunction } from 'i18next';
import { withTranslation, WithTranslation } from 'react-i18next';
import AcceptTermsAndCondition from './pages/accept-terms-conditions/AcceptTermsAndCondition';
import { IUserData } from './models/login';
import Home from './pages/home/Home';
import PayByWeb from './pages/pay-by-web/PayByWeb';
import DriverDebt from './pages/driver-debt/DriverDebt';
import DriverSubscriptions from './pages/driver-subscriptions/DriverSubscriptions';
import { store } from './store';
import CpoInternalTransfers from './pages/cpo-internal-transfers/CPOInternalTransfers';
import TransferDetail from './pages/cpo-internal-transfers/TransferDetail';
import { withRouter } from './components/custom-hoc/withRouter';
import moment from 'moment';
import 'moment/locale/is';
import 'moment/locale/es';
const FleetDashboardPage = React.lazy(() => import('./fleet-portal/pages/dashboard/DashboardPage'));
const InvoiceDetail = React.lazy(() => import('./fleet-portal/pages/payment-history/InvoiceDetail'));
const RefundRequest = React.lazy(() => import('./pages/refund-request/RefundRequests'));
const PaymentHistory = React.lazy(() => import('./fleet-portal/pages/payment-history/PaymentHistory'));
const ChargingHistory = React.lazy(() => import('./fleet-portal/pages/charging-history/ChargingHistory'));
const ApprovalGrid = React.lazy(() => import('./pages/driver-award/ApprovalGrid'));
const DriverAwardGrid = React.lazy(() => import('./pages/driver-award/DriverAwardGrid'));
const AccessDenied = React.lazy(() => import('./components/shared/AccessDenied'));
const DashboardPage = React.lazy(() => import('./pages/dashboard/DashboardPage'));
const UserGroups = React.lazy(() => import('./pages/userGroup/UserGroups'));
const DriverGroups = React.lazy(() => import('./pages/driverGroup/DriverGroups'));
const Users = React.lazy(() => import('./pages/user/Users'));
const Vat = React.lazy(() => import('./pages/vat/ManageVAT'));
const Tags = React.lazy(() => import('./pages/tag/Tags'));
const DriverAcoountBalance = React.lazy(() => import('./pages/driverAccountBalance/DriverAccountBalance'));
const ChargeStations = React.lazy(() => import('./pages/charge-station/ChargeStations'));
const DriverTransactionGrid = React.lazy(() => import('./pages/driverTransaction/DriverTransactionGrid'));
const PromotionsRequestGrid = React.lazy(() => import('./pages/promotionsRequest/PromotionsRequestGrid'));
const DriverPromotions = React.lazy(() => import('./pages/driver-promotions/DriverPromotions'));
const ScheduleSetting = React.lazy(() => import('./pages/paymentScheduleSetting/ScheduleSetting'));
const PaymentApproval = React.lazy(() => import('./pages/PaymentApproval/PaymentApproval'));
const PaymentFailures = React.lazy(() => import('./pages/paymentFailures/ManagePaymentFailures'));
const ChargeTariff = React.lazy(() => import('./pages/charge-tariff/ChargeTariff'));
const Amenity = React.lazy(() => import('./pages/amenity/Amenitys'));
const ThirdPartyPromotions = React.lazy(() => import('./pages/partner-promotions/PartnerPromotions'));
const TermsConditions = React.lazy(() => import('./pages/terms-conditions/TermsAndConditions'));
const ReferralPromotion = React.lazy(() => import('./pages/referral-Promotion/ReferralPromotion'));
const CPOInterfaces = React.lazy(() => import('./pages/cpo-interface/CPOInterfaces'));
const DataAggregator = React.lazy(() => import('./pages/data-aggregator/DataAggregator'));
const PSPSetting = React.lazy(() => import('./pages/psp-settings/PSPSetting'));
const RFIDCards = React.lazy(() => import('./pages/rfid-cards/RFIDCards'));
const RewardPromotion = React.lazy(() => import('./pages/reward-promotion/RewardPromotion'));
const PaymentSecure = React.lazy(() => import('./fleet-portal/pages/payment-secure/PaymentSecure'));
const OrganisationTransactionGrid = React.lazy(
    () => import('./pages/organisationTransaction/OrganisationTransactionGrid'),
);
const AdminInvoiceDetail = React.lazy(() => import('./pages/organisationTransaction/InvoiceDetails'));
const OrganisationAccountBalance = React.lazy(
    () => import('./pages/organisationAccountBalance/OrganisationAccountBalance'),
);
const OrganisationInvoices = React.lazy(() => import('./pages/organisation-invoices/OrganisationInvoices'));
const ManageOrganisation = React.lazy(() => import('./pages/organisation/ManageOrganisation'));
const OrganisationDashboard = React.lazy(() => import('./pages/organisationDashboard/OrganisationDashboard'));
const Vehicle = React.lazy(() => import('./pages/vehicle/Vehicle'));
const IncompleteSessions = React.lazy(() => import('./pages/incomplete-sessions/IncompleteSessions'));
const OCPISessions = React.lazy(() => import('./pages/ocpi-sessions/OCPISessions'));
const TransactionLogs = React.lazy(() => import('./pages/transaction-logs/TransactionLogs'));
const RFIDRequests = React.lazy(() => import('./pages/rfid-requests/RFIDRequests'));

const DriverVehicleAccounts = React.lazy(
    () => import('./fleet-portal/pages/driver-vehicle-account/DriverVehicleAccounts'),
);
const Configuration = React.lazy(() => import('./pages/configurations/Configurations'));
const MyProfile = React.lazy(() => import('./pages/my-profile/MyProfile'));
const RFIDCardsFleet = React.lazy(() => import('./fleet-portal/pages/rfid-cards/RFIDCards'));
const APICredentials = React.lazy(() => import('./fleet-portal/pages/apiCredentials/APICredentials'));
const PaymentConfiguration = React.lazy(
    () => import('./fleet-portal/pages/payment-configuration/PaymentConfiguration'),
);
const CardReader = React.lazy(() => import('./pages/card-readers/CardReader'));
const CardScheme = React.lazy(() => import('./pages/card-schemes/CardScheme'));
const ChargeStationsMap = React.lazy(() => import('./pages/charge-stations-map/ChargeStationsMap'));
const FleetProfile = React.lazy(() => import('./fleet-portal/pages/fleet-profile/FleetProfile'));
const AccessGroups = React.lazy(() => import('./pages/access-groups/AccessGroups'));
const AccessGroupRequests = React.lazy(() => import('./pages/access-group-requests/AccessGroupRequests'));
const FleetAccessGroups = React.lazy(() => import('./fleet-portal/pages/fleet-access-groups/FleetAccessGroups'));
const FleetAccessGroupRequests = React.lazy(
    () => import('./fleet-portal/pages/fleet-access-group-requests/FleetAccessGroupRequests'),
);
const EmailLogs = React.lazy(() => import('./pages/email-logs/EmailLogs'));
const Alerts = React.lazy(() => import('./pages/alerts/Alerts'));
const SubscriptionSettings = React.lazy(() => import('./pages/subscription-settings/SubscriptionSettings'));
const AdvertisingDevices = React.lazy(
    () => import('./advertising-platform/pages/advertising-devices/AdvertisingDevices'),
);
const AdvertisingVideos = React.lazy(() => import('./advertising-platform/pages/advertising-videos/AdvertisingVideos'));
const AdvertisingCredentials = React.lazy(
    () => import('./advertising-platform/pages/advertising-credentials/AdvertisingCredentials'),
);
const MediaTerminalLogsGrid = React.lazy(
    () => import('./advertising-platform/pages/advertising-devices/MediaTerminalLogsGrid'),
);
const FleetDriverSpendHistory = React.lazy(
    () => import('./fleet-portal/pages/fleet-driver-spend-history/FleetDriverSpendHistory'),
);
const AcceptedTermsAndConditions = React.lazy(
    () => import('./pages/accept-terms-conditions/AcceptedTermsAndConditions'),
);
const DriverDebtorLetters = React.lazy(() => import('./pages/driver-debtor-letters/DriverDebtorLetters'));
const SubscriptionImages = React.lazy(() => import('./pages/subscription-images/SubscriptionImages'));
const DriverPaymentCards = React.lazy(() => import('./pages/driver-payment-cards/DriverPaymentCards'));

const GlobalService = React.lazy(() => import('./pages/global-service/GlobalService'));

const queryStringLang = new URLSearchParams(window.location.search);
const languageInfo = store?.getState()?.LanguageInfo?.supportedLanguages;
const changelanguage = languageInfo
    ? languageInfo?.filter(
          (item) => item?.code === queryStringLang.get('langCode') || item?.code === queryStringLang.get('language'),
      )[0]
    : { code: queryStringLang.get('langCode') || queryStringLang.get('language') };

Amplify.configure(amplifyConfig);
interface IAppProps extends IApplicationProps {
    breakpoint: string;
    t: TFunction;
}
interface IState {
    isOpen: boolean;
    isReady: boolean;
    showCookies: boolean;
}
class App extends Component<IAppProps & WithTranslation, IState> {
    loginService: LoginService;
    loginApiService: LoginAPIService;
    constructor(props: IAppProps & WithTranslation) {
        super(props);
        this.state = { isOpen: false, isReady: false, showCookies: false };
        this.loginService = new LoginService();
        this.loginApiService = new LoginAPIService();
    }

    async componentDidMount() {
        await this.getLanguageThroughQueryparams();
        await this.tryAutoSignIn();
        await this.getCompanyName();
        moment.locale(store?.getState()?.UserData?.language?.code);
    }

    getCompanyName = async () => {
        let config = await this.loginApiService.getRegionConfigurations();
        this.props.setCompanyName(
            config.data.company_name
                ? config.data.company_name
                : config.data.company_brand_name
                ? config.data.company_brand_name
                : 'Instavolt',
        );
    };

    getLanguageThroughQueryparams = async () => {
        if (queryStringLang.get('language')) {
            this.props.changeLanguage(changelanguage);
        }
    };

    tryAutoSignIn = async () => {
        try {
            const currentUser = await this.loginService.getCognitoUser({
                bypassCache: true,
            });
            if (currentUser) {
                await this.loginApiService
                    .userDetails()
                    .then((userData: IUserData) => {
                        this.props.login(currentUser);
                        this.props.userDetail(userData);
                        this.props.setCurrencyDetails(userData?.currency_details);
                        this.setState({ isReady: true });
                        if (userData && userData.terms_and_condition_required) {
                            this.props.history.push('/termsAndConditions');
                        }
                    })
                    .catch((m) => {
                        if (
                            m.response &&
                            m.response.data &&
                            m.response.data.message &&
                            m.response.data.message.includes('Organisation is deleted')
                        ) {
                            toast.error(m.response.data.message);
                        } else if (m && m.includes('Organisation is deleted')) {
                            toast.error(m.toString());
                        } else {
                            toast.error(this.props.t('login.errors.common'));
                        }
                        this.props.logout();
                        this.setState({ isReady: true });
                    });
            }
        } catch (error) {
            this.props.logout();
            this.setState({ isReady: true });
        }
    };

    checkNotAuthenticatedUser = () => {
        if (!this.props.userData?.id) {
            return <LoginPage {...this.props} key={this.props.location.key} />;
        } else if (this.props.userData.terms_and_condition_required) {
            return <Navigate replace to="/termsAndConditions" />;
        } else {
            return <Navigate replace to="/" />;
        }
    };

    checkAuthenticatedUser = (component) => {
        if (
            !this.props.userData ||
            !this.props.userData.authConfigs ||
            !this.props.userData.authConfigs.accessToken ||
            this.props.userData.authConfigs.accessToken === ''
        ) {
            return <Navigate replace to="/login" />;
        } else {
            return component;
        }
    };

    checkAuthenticatedUserWithPermission = (callBack) => {
        if (
            !this.props.userData ||
            !this.props.userData.authConfigs ||
            !this.props.userData.authConfigs.accessToken ||
            this.props.userData.authConfigs.accessToken === ''
        ) {
            return <Navigate replace to="/login" />;
        } else {
            return callBack();
        }
    };

    render() {
        const { t } = this.props;
        //Over Ride Window in this case with Toast
        return (
            <>
                {this.state.isReady && (
                    <Routes>
                        <Route path="/login" element={this.checkNotAuthenticatedUser()} />
                        <Route
                            path="/termsAndConditions"
                            element={this.checkAuthenticatedUser(
                                <AcceptTermsAndCondition {...this.props} key={this.props.location.key} />,
                            )}
                        />

                        <Route element={<MainLayout {...this.props} key={this.props.location.key} />}>
                            <Route
                                path="/my-profile"
                                element={this.checkAuthenticatedUser(
                                    <MyProfile {...this.props} key={this.props.location.key} />,
                                )}
                            />
                            <Route
                                path="/terms-and-conditions"
                                element={this.checkAuthenticatedUser(
                                    <AcceptedTermsAndConditions {...this.props} key={this.props.location.key} />,
                                )}
                            />
                            <Route
                                path="/"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        (ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.FLEET_DASHBOARD.FLEET_DASHBOARD_USER_SESSION,
                                        ) ||
                                            ability.can(
                                                Common.Actions.CAN_VIEW,
                                                Common.Modules.FLEET_DASHBOARD.FLEET_DASHBOARD_ENERGY,
                                            ) ||
                                            ability.can(
                                                Common.Actions.CAN_VIEW,
                                                Common.Modules.FLEET_DASHBOARD.FLEET_DASHBOARD_EXPENSE,
                                            ) ||
                                            ability.can(
                                                Common.Actions.CAN_VIEW,
                                                Common.Modules.FLEET_DASHBOARD.FLEET_DASHBOARD_REMAINING_CREDIT,
                                            ) ||
                                            ability.can(
                                                Common.Actions.CAN_VIEW,
                                                Common.Modules.FLEET_DASHBOARD.FLEET_DASHBOARD_TRANSACTION,
                                            ) ||
                                            ability.can(
                                                Common.Actions.CAN_VIEW,
                                                Common.Modules.FLEET_DASHBOARD.FLEET_DASHBOARD_DRIVER_PIE_CHART,
                                            )) &&
                                        this.props.userData.isOrganisation
                                    ) {
                                        return <FleetDashboardPage {...this.props} key={this.props.location.key} />;
                                    } else if (
                                        !this.props.userData.isOrganisation &&
                                        (ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.DASHBOARD.DASHBOARD_USER_SESSION,
                                        ) ||
                                            ability.can(
                                                Common.Actions.CAN_VIEW,
                                                Common.Modules.DASHBOARD.DASHBOARD_DRIVER,
                                            ) ||
                                            ability.can(
                                                Common.Actions.CAN_VIEW,
                                                Common.Modules.DASHBOARD.DASHBOARD_ENERGY,
                                            ) ||
                                            ability.can(
                                                Common.Actions.CAN_VIEW,
                                                Common.Modules.DASHBOARD.DASHBOARD_FAILED_PAYMENTS,
                                            ) ||
                                            ability.can(
                                                Common.Actions.CAN_VIEW,
                                                Common.Modules.DASHBOARD.DASHBOARD_INCOME,
                                            ) ||
                                            ability.can(
                                                Common.Actions.CAN_VIEW,
                                                Common.Modules.DASHBOARD.DASHBOARD_OUTSTANDING_FAILED_PAYMENTS,
                                            ) ||
                                            ability.can(
                                                Common.Actions.CAN_VIEW,
                                                Common.Modules.DASHBOARD.DASHBOARD_TRANSACTION,
                                            ) ||
                                            ability.can(
                                                Common.Actions.CAN_VIEW,
                                                Common.Modules.DASHBOARD.DASHBOARD_VOLT_ACCUMULATED,
                                            ) ||
                                            ability.can(
                                                Common.Actions.CAN_VIEW,
                                                Common.Modules.DASHBOARD.DASHBOARD_VOLT_CLAIMED,
                                            ) ||
                                            ability.can(
                                                Common.Actions.CAN_VIEW,
                                                Common.Modules.DASHBOARD.DASHBOARD_CLAIMED_VOLT,
                                            ) ||
                                            ability.can(
                                                Common.Actions.CAN_VIEW,
                                                Common.Modules.DASHBOARD.DASHBOARD_ISSUED_VOLT,
                                            ) ||
                                            ability.can(
                                                Common.Actions.CAN_VIEW,
                                                Common.Modules.DASHBOARD.DASHBOARD_LIABILITY_VOLT,
                                            ) ||
                                            ability.can(
                                                Common.Actions.CAN_VIEW,
                                                Common.Modules.DASHBOARD.DASHBOARD_VOLT_LAPSED,
                                            ) ||
                                            ability.can(
                                                Common.Actions.CAN_VIEW,
                                                Common.Modules.DASHBOARD.DASHBOARD_DRIVER_PIE_CHART,
                                            ) ||
                                            ability.can(
                                                Common.Actions.CAN_VIEW,
                                                Common.Modules.DASHBOARD.DASHBOARD_REFERRAL_PROMOTION,
                                            ))
                                    ) {
                                        return <DashboardPage {...this.props} key={this.props.location.key} />;
                                    } else {
                                        return <Home />;
                                    }
                                })}
                            />
                            <Route
                                path="/users"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        this.props.userData.isOrganisation
                                            ? !ability.can(
                                                  Common.Actions.CAN_VIEW,
                                                  Common.Modules.FLEET_PORTAL.FLEET_SETTINGS.USERS,
                                              )
                                            : !ability.can(Common.Actions.CAN_VIEW, Common.Modules.USERS)
                                    ) {
                                        return <AccessDenied />;
                                    }
                                    return <Users {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/users/groups"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (!ability.can(Common.Actions.CAN_VIEW, Common.Modules.USERGROUPS)) {
                                        return <AccessDenied />;
                                    }
                                    return <UserGroups {...this.props} key={this.props.location.key} />;
                                })}
                            />

                            <Route
                                path="/drivers"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (!ability.can(Common.Actions.CAN_VIEW, Common.Modules.DRIVERS.ACCOUNTS)) {
                                        return <AccessDenied />;
                                    }
                                    return <Drivers {...this.props} key={this.props.location.key} />;
                                })}
                            />

                            <Route
                                path="/drivers/groups"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        this.props.userData.isOrganisation
                                            ? !ability.can(
                                                  Common.Actions.CAN_VIEW,
                                                  Common.Modules.FLEET_PORTAL.DRIVER_VEHICLE.DRIVER_GROUPS,
                                              )
                                            : !ability.can(
                                                  Common.Actions.CAN_VIEW,
                                                  Common.Modules.DRIVERS.DRIVER_GROUPS,
                                              )
                                    ) {
                                        return <AccessDenied />;
                                    }
                                    return <DriverGroups {...this.props} key={this.props.location.key} />;
                                })}
                            />

                            <Route
                                path="/drivers/transactions/:driverId?"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (!ability.can(Common.Actions.CAN_VIEW, Common.Modules.DRIVERS.TRANSACTIONS)) {
                                        return <AccessDenied />;
                                    }
                                    return <DriverTransactionGrid {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/drivers/award-balance"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (!ability.can(Common.Actions.CAN_VIEW, Common.Modules.DRIVERS.IVAWARDS)) {
                                        return <AccessDenied />;
                                    }
                                    return <DriverAwardGrid {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/drivers/rewards-approval"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(Common.Actions.CAN_VIEW, Common.Modules.DRIVERS.IVAWARDS_APPROVAL)
                                    ) {
                                        return <AccessDenied />;
                                    }
                                    return <ApprovalGrid {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/drivers/requested-promotions"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.DRIVERS.REQUESTED_PROMOTIONS,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }
                                    return <PromotionsRequestGrid {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/drivers/balance"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (!ability.can(Common.Actions.CAN_VIEW, Common.Modules.DRIVERS.ACCOUNT_BALANCE)) {
                                        return <AccessDenied />;
                                    }
                                    return <DriverAcoountBalance {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/drivers/premium-subscriptions/:driverId?"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.MANAGE_PREMIUM_SUBSCRIPTIONS,
                                            Common.Modules.DRIVERS.ACCOUNTS,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }
                                    return <DriverSubscriptions {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/drivers/:driverId/payment-cards"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.SEARCH_DRIVER_PAYMENT_CARDS,
                                            Common.Modules.DRIVERS.ACCOUNTS,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }
                                    return <DriverPaymentCards {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/driver-debt"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (!ability.can(Common.Actions.CAN_VIEW, Common.Modules.DRIVERS.DRIVER_DEBT)) {
                                        return <AccessDenied />;
                                    }
                                    return <DriverDebt {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/settings/vat"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (!ability.can(Common.Actions.CAN_VIEW, Common.Modules.MASTERS.VAT)) {
                                        return <AccessDenied />;
                                    }
                                    return <Vat {...this.props} key={this.props.location.key} />;
                                })}
                            />

                            <Route
                                path="/settings/tags"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (!ability.can(Common.Actions.CAN_VIEW, Common.Modules.MASTERS.TAGS)) {
                                        return <AccessDenied />;
                                    }
                                    return <Tags {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/settings/term-conditions"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.MASTERS.TERMS_AND_CONDITIONS,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }
                                    return <TermsConditions {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/settings/amenities"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (!ability.can(Common.Actions.CAN_VIEW, Common.Modules.MASTERS.AMENITY)) {
                                        return <AccessDenied />;
                                    }
                                    return <Amenity {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/charge-stations"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (!ability.can(Common.Actions.CAN_VIEW, Common.Modules.CHARGE_STATIONS)) {
                                        return <AccessDenied />;
                                    }
                                    return <ChargeStations {...this.props} key={this.props.location.key} />;
                                })}
                            />

                            <Route
                                path="/charge-stations/map-view"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(Common.Actions.CAN_VIEW, Common.Modules.CHARGE_STATIONS_MAP_VIEW)
                                    ) {
                                        return <AccessDenied />;
                                    }
                                    return <ChargeStationsMap {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/access-groups"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (!ability.can(Common.Actions.CAN_VIEW, Common.Modules.ACCESS_GROUPS)) {
                                        return <AccessDenied />;
                                    }
                                    return <AccessGroups {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/access-group-requests"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (!ability.can(Common.Actions.CAN_VIEW, Common.Modules.ACCESS_GROUP_REQUESTS)) {
                                        return <AccessDenied />;
                                    }
                                    return <AccessGroupRequests {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/pay-by-web"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (!ability.can(Common.Actions.CAN_VIEW, Common.Modules.PAY_BY_WEB)) {
                                        return <AccessDenied />;
                                    }
                                    return <PayByWeb {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/cpos/accounts"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (!ability.can(Common.Actions.CAN_VIEW, Common.Modules.CPOS.ACCOUNTS)) {
                                        return <AccessDenied />;
                                    }
                                    return <CPOInterfaces {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/cpos/internal-transfer"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.CPOS.CPOS_INTERNAL_TRANSFER,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }
                                    return <CpoInternalTransfers {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/settings/data-aggregators"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.MASTERS.SETTINGS_DATA_AGGREGATORS,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }
                                    return <DataAggregator {...this.props} key={this.props.location.key} />;
                                })}
                            />

                            <Route
                                path="/settings/payment-service-provider"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (!ability.can(Common.Actions.CAN_VIEW, Common.Modules.MASTERS.PSP)) {
                                        return <AccessDenied />;
                                    }
                                    return <PSPSetting {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/settings/email-logs"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (!ability.can(Common.Actions.CAN_VIEW, Common.Modules.SETTINGS_EMAIL_LOGS)) {
                                        return <AccessDenied />;
                                    }
                                    return <EmailLogs {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/settings/ocpi-error-logs"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(Common.Actions.CAN_VIEW, Common.Modules.SETTINGS_OCPI_ERROR_LOGS)
                                    ) {
                                        return <AccessDenied />;
                                    }
                                    return <Alerts {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/promotions/premium-subscriptions"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.PROMOTIONS.PROMOTIONS_PREMIUM_SUBSCRIPTIONS,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }
                                    return <SubscriptionSettings {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/promotions/premium-subscription-images"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.PROMOTIONS.PROMOTIONS_PREMIUM_SUBSCRIPTION_IMAGES,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }
                                    return <SubscriptionImages {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/settings/driver-debtor-letters"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.MASTERS.SETTINGS_DRIVER_DEBTOR_LETTER,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }
                                    return <DriverDebtorLetters {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/settings/global-service"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.MASTERS.SETTINGS_GLOBAL_SERVICE,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }
                                    return <GlobalService {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/rfid-cards"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (!ability.can(Common.Actions.CAN_VIEW, Common.Modules.RFID.RFID_CARDS)) {
                                        return <AccessDenied />;
                                    }
                                    return <RFIDCards {...this.props} key={this.props.location.key} />;
                                })}
                            />

                            <Route
                                path="/rfid/card-readers"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (!ability.can(Common.Actions.CAN_VIEW, Common.Modules.RFID.RFID_CARD_READERS)) {
                                        return <AccessDenied />;
                                    }
                                    return <CardReader {...this.props} key={this.props.location.key} />;
                                })}
                            />

                            <Route
                                path="/rfid/card-schemes"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (!ability.can(Common.Actions.CAN_VIEW, Common.Modules.RFID.RFID_CARD_SCHEMES)) {
                                        return <AccessDenied />;
                                    }
                                    return <CardScheme {...this.props} key={this.props.location.key} />;
                                })}
                            />

                            <Route
                                path="/payments/schedule"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (!ability.can(Common.Actions.CAN_VIEW, Common.Modules.PAYMENTS.SCHEDULE)) {
                                        return <AccessDenied />;
                                    }
                                    return <ScheduleSetting {...this.props} key={this.props.location.key} />;
                                })}
                            />

                            <Route
                                path="/promotions/drivers"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.PROMOTIONS.DRIVER_PROMOTIONS,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }
                                    return <DriverPromotions {...this.props} key={this.props.location.key} />;
                                })}
                            />

                            <Route
                                path="/payments/approval"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (!ability.can(Common.Actions.CAN_VIEW, Common.Modules.PAYMENTS.APPROVAL)) {
                                        return <AccessDenied />;
                                    }
                                    return <PaymentApproval {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/payments/failure/:driverId?"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (!ability.can(Common.Actions.CAN_VIEW, Common.Modules.PAYMENTS.FAIL_PAYMENTS)) {
                                        return <AccessDenied />;
                                    }
                                    return <PaymentFailures {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/settings/tariffs"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.PROMOTIONS.TARIFF_PROMOTIONS,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }
                                    return <ChargeTariff {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/promotions/partners"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.PROMOTIONS.PARTNER_PROMOTIONS,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }
                                    return <ThirdPartyPromotions {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/promotions/referral"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.PROMOTIONS.REFERRAL_PROMOTIONS,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }
                                    return <ReferralPromotion {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/promotions/rewards"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.PROMOTIONS.REWARD_PROMOTIONS,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }
                                    return <RewardPromotion {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/drivers/vehicles"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (!ability.can(Common.Actions.CAN_VIEW, Common.Modules.DRIVERS.VEHICLES)) {
                                        return <AccessDenied />;
                                    }
                                    return <Vehicle {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/charging-sessions/incomplete"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.CHARGING_SESSIONS.INCOMPLETE_SESSIONS,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }

                                    return <IncompleteSessions {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/charging-sessions/ocpi"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.CHARGING_SESSIONS.OCPI_SESSIONS,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }

                                    return <OCPISessions {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/organisations/accounts"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (!ability.can(Common.Actions.CAN_VIEW, Common.Modules.ORGANISATIONS.ACCOUNTS)) {
                                        return <AccessDenied />;
                                    }
                                    return <ManageOrganisation {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/organisations/dashboard"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !this.props.userData.isOrganisation &&
                                        (ability.can(
                                            Common.Actions.VIEW_DRIVERS_USAGE_DASHBOARD,
                                            Common.Modules.ORGANISATIONS.ADMIN_ORGANISATION_DASHBOARD,
                                        ) ||
                                            ability.can(
                                                Common.Actions.VIEW_TOTAL_DRIVERS_DASHBOARD,
                                                Common.Modules.ORGANISATIONS.ADMIN_ORGANISATION_DASHBOARD,
                                            ) ||
                                            ability.can(
                                                Common.Actions.VIEW_REMAINING_CREDIT_DASHBOARD,
                                                Common.Modules.ORGANISATIONS.ADMIN_ORGANISATION_DASHBOARD,
                                            ) ||
                                            ability.can(
                                                Common.Actions.VIEW_RFID_SUMMARY_DASHBOARD,
                                                Common.Modules.ORGANISATIONS.ADMIN_ORGANISATION_DASHBOARD,
                                            ) ||
                                            ability.can(
                                                Common.Actions.VIEW_TOTAL_ENERGY_DASHBOARD,
                                                Common.Modules.ORGANISATIONS.ADMIN_ORGANISATION_DASHBOARD,
                                            ) ||
                                            ability.can(
                                                Common.Actions.VIEW_USER_SESSION_DASHBOARD,
                                                Common.Modules.ORGANISATIONS.ADMIN_ORGANISATION_DASHBOARD,
                                            ) ||
                                            ability.can(
                                                Common.Actions.VIEW_TOTAL_INCOME_DASHBOARD,
                                                Common.Modules.ORGANISATIONS.ADMIN_ORGANISATION_DASHBOARD,
                                            ))
                                    ) {
                                        return <OrganisationDashboard {...this.props} key={this.props.location.key} />;
                                    } else {
                                        return <AccessDenied />;
                                    }
                                })}
                            />
                            <Route
                                path="/transaction-logs"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (!ability.can(Common.Actions.CAN_VIEW, Common.Modules.TRANSACTION_LOGS)) {
                                        return <AccessDenied />;
                                    }
                                    return <TransactionLogs {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/organisations/account-balance"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.ORGANISATIONS.ACCOUNT_BALANCE,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }
                                    return <OrganisationAccountBalance {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/organisations/transactions/:organisationId?"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.ORGANISATIONS.ORGANISATIONS_TRANSACTIONS,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }
                                    return (
                                        <OrganisationTransactionGrid {...this.props} key={this.props.location.key} />
                                    );
                                })}
                            />
                            <Route
                                path="/organisations/invoices"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.ORGANISATIONS.ORGANISAIONS_INVOICES,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }
                                    return <OrganisationInvoices {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/admin/payment/invoice/:id"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.ORGANISATIONS.ORGANISATIONS_TRANSACTIONS,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }

                                    return <AdminInvoiceDetail {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/admin/cpo/transfer-detail/:id"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.CPOS.CPOS_INTERNAL_TRANSFER,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }

                                    return <TransferDetail {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/drivers/rfid-requests"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(Common.Actions.CAN_VIEW, Common.Modules.DRIVERS.RFID_CARD_REQUESTS)
                                    ) {
                                        return <AccessDenied />;
                                    }

                                    return <RFIDRequests {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/fleet/access-groups"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.FLEET_PORTAL.FLEET_STATIONS.FLEET_ACCESS_GROUPS,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }

                                    return <FleetAccessGroups {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/fleet/access-group-requests"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.FLEET_PORTAL.FLEET_STATIONS.FLEET_ACCESS_GROUP_REQUESTS,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }

                                    return <FleetAccessGroupRequests {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/fleet/drivers-vehicles"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.FLEET_PORTAL.DRIVER_VEHICLE.DRIVER_VEHICLE_ACCOUNT,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }

                                    return <DriverVehicleAccounts {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/fleet/driver-spend-history"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.FLEET_PORTAL.DRIVER_VEHICLE.FLEET_DRIVER_SPEND_LIMIT_HISTORY,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }

                                    return <FleetDriverSpendHistory {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/fleet/cdrs"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(Common.Actions.CAN_VIEW, Common.Modules.FLEET_HISTORY.CDR_HISTORY)
                                    ) {
                                        return <AccessDenied />;
                                    }
                                    return <ChargingHistory {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/fleet/payment"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.FLEET_HISTORY.PAYMENT_HISTORY,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }

                                    return <PaymentHistory {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/fleet/payment/invoice/:id"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.FLEET_HISTORY.PAYMENT_HISTORY,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }

                                    return <InvoiceDetail {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/settings/configurations"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.MASTERS.SETTINGS_CONFIGURATIONS,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }

                                    return <Configuration {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/fleet-settings/rfid-cards"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.FLEET_PORTAL.FLEET_SETTINGS.RFID_CARDS,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }
                                    return <RFIDCardsFleet {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/fleet-settings/api-key"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.FLEET_PORTAL.FLEET_SETTINGS.API_KEY,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }
                                    return <APICredentials {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/fleet/payment-source"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.FLEET_PORTAL.FLEET_SETTINGS.FLEET_PAYMENT_SOURCE,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }
                                    return <PaymentConfiguration {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/fleet/paymentSecure"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.FLEET_PORTAL.FLEET_SETTINGS.FLEET_PAYMENT_SOURCE,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }
                                    return <PaymentSecure {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/fleet-settings/profile"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.FLEET_PORTAL.FLEET_SETTINGS.FLEET_SETTINGS_PROFILE,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }
                                    return <FleetProfile {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/payments/refund-approvals"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.PAYMENTS.PAYMENT_REFUND_APPROVALS,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }
                                    return <RefundRequest {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/advertising/devices"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.ADVERTISING.ADVERTISING_DEVICES,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }
                                    return <AdvertisingDevices {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/advertising/devices/:id/media-terminal-logs"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.VIEW_MEDIA_PLAY_LOG_HISTORY,
                                            Common.Modules.ADVERTISING.ADVERTISING_DEVICES,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }

                                    return <MediaTerminalLogsGrid {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/advertising/videos"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.ADVERTISING.ADVERTISING_VIDEOS,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }
                                    return <AdvertisingVideos {...this.props} key={this.props.location.key} />;
                                })}
                            />
                            <Route
                                path="/advertising/credentials"
                                element={this.checkAuthenticatedUserWithPermission(() => {
                                    if (
                                        !ability.can(
                                            Common.Actions.CAN_VIEW,
                                            Common.Modules.ADVERTISING.ADVERTISING_CREDENTIALS,
                                        )
                                    ) {
                                        return <AccessDenied />;
                                    }
                                    return <AdvertisingCredentials {...this.props} key={this.props.location.key} />;
                                })}
                            />
                        </Route>
                        <Route path="/" element={<Navigate replace to="/login" />} />
                        <Route path="*" element={<Navigate to="/login" />} />
                        {/* <Redirect to="/login" /> */}
                    </Routes>
                )}
                <Spinner />
                <ToastContainer />
                {this.state.showCookies && (
                    <CookieConsent buttonText={t('cookiePolicy.iAccept')} expires={30}>
                        {t('cookiePolicy.text')}
                        <a href="" target="_blank" className="cookiepolicy-action">
                            {t('cookiePolicy.action')}
                        </a>
                    </CookieConsent>
                )}
            </>
        );
    }
}
const mapStateToProps = (state: AppState) => ({
    userData: state.UserData,
    errors: state.errorLog,
});
const mapDispatchtoProps = (dispatch: Dispatch) => bindActionCreators(_.assign({}, AppActionCreators), dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchtoProps)(withTranslation()(App) as any) as any);
